import { useContext } from 'react';

import { getFaqItem } from '@monetization/hpaip-components-library';
import { useTranslation } from 'react-i18next';

import { FlowOrchestratorContext } from '@storefront/app/flow-orchestrator/context';
import { FlowType } from '@storefront/app/flow-orchestrator/types';
import { getTableData } from '@storefront/app/v2/pdp-config/shared-components/faq/faq.utils';
import { BundleProduct } from '@storefront/data-commerce';
import { NamespacesI18n } from '@storefront/i18n';
import {
  TranslatedText,
  TranslatedTextProps,
} from '@storefront/shared-components/translated-text/translated-text';
import { Cancel } from '@storefront/types/Product';

import { getFaqQuestions } from './useGetFaqs';

interface GetFaqsProps {
  flowType: FlowType;
  cancellationList: Cancel[];
  nameSpace?: NamespacesI18n;
}

export const useGetFaqsV2 = ({
  flowType,
  cancellationList,
  nameSpace = NamespacesI18n.PDP_CONFIG,
}: GetFaqsProps): Array<any> => {
  const { i18n, t } = useTranslation(nameSpace);
  const { isSMB } = useContext(FlowOrchestratorContext);

  let flow: string;
  if (flowType === FlowType.Pc) {
    flow = 'pc';
  } else if (isSMB) {
    flow = 'smbPrinter';
  } else {
    flow = 'printer';
  }

  const { faqQuestions, reducedLinks } = getFaqQuestions(
    i18n,
    flow,
    true,
    nameSpace
  );

  return faqQuestions.map(
    ({ question, answer, table, answerComplement, centralizedAnswer, list }) =>
      getFaqItem({
        question,
        answer,
        answer2: answerComplement,
        centralizedAnswer,
        list,
        translationComponents: reducedLinks,
        TranslationWrapperComponent: (props: TranslatedTextProps) => (
          <TranslatedText {...props} linkStyle="electric-blue" />
        ),
        table,
        tableProps: table
          ? getTableData({
              cancellationList,
              type: table,
              t,
            })
          : undefined,
      })
  );
};
